import Icon from '../../../components/AppIcon';

const BusinessInformation = ({ business }) => {
  return (
    <div className="bg-card rounded-lg shadow-card p-6 mb-6">
      <h2 className="text-2xl font-bold text-foreground mb-4 flex items-center gap-2">
        <Icon name="Info" size={24} color="var(--color-primary)" />
        Información del Negocio
      </h2>
      {/* Description */}
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-foreground mb-2">Descripción</h3>
        <p className="text-muted-foreground leading-relaxed">{business?.description}</p>
      </div>
      {/* Location with Map */}
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-foreground mb-3 flex items-center gap-2">
          <Icon name="MapPin" size={20} color="var(--color-primary)" />
          Ubicación
        </h3>
        <p className="text-foreground mb-3">{business?.fullAddress}</p>
        <div className="w-full rounded-lg overflow-hidden bg-muted" style={{ height: '300px' }}>
          <iframe
            width="100%"
            height="100%"
            loading="lazy"
            title={business?.name}
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps?q=${business?.coordinates?.lat},${business?.coordinates?.lng}&z=15&output=embed`}
            className="border-0"
          />
        </div>
      </div>
      {/* Operating Hours */}
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-foreground mb-3 flex items-center gap-2">
          <Icon name="Clock" size={20} color="var(--color-primary)" />
          Horario de Atención
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {business?.operatingHours?.map((schedule, index) => (
            <div key={index} className="flex items-center justify-between bg-muted px-4 py-2 rounded-lg">
              <span className="text-foreground font-medium">{schedule?.day}</span>
              <span className="text-muted-foreground">{schedule?.hours}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Contact Details */}
      <div>
        <h3 className="text-lg font-semibold text-foreground mb-3 flex items-center gap-2">
          <Icon name="Phone" size={20} color="var(--color-primary)" />
          Contacto
        </h3>
        <div className="space-y-3">
          <a
            href={`tel:${business?.phone}`}
            className="flex items-center gap-3 bg-muted px-4 py-3 rounded-lg hover:bg-primary/10 transition-colors group"
          >
            <Icon name="Phone" size={20} color="var(--color-primary)" />
            <span className="text-foreground group-hover:text-primary transition-colors">{business?.phone}</span>
          </a>
          <a
            href={`mailto:${business?.email}`}
            className="flex items-center gap-3 bg-muted px-4 py-3 rounded-lg hover:bg-primary/10 transition-colors group"
          >
            <Icon name="Mail" size={20} color="var(--color-primary)" />
            <span className="text-foreground group-hover:text-primary transition-colors">{business?.email}</span>
          </a>
          <a
            href={`https://wa.me/${business?.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-success/10 px-4 py-3 rounded-lg hover:bg-success/20 transition-colors group"
          >
            <Icon name="MessageCircle" size={20} color="var(--color-success)" />
            <span className="text-success group-hover:text-success transition-colors">{business?.whatsappDisplay}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default BusinessInformation;